import { render } from "./CxMenu.vue?vue&type=template&id=0a337d4b"
import script from "./CxMenu.vue?vue&type=script&lang=js"
export * from "./CxMenu.vue?vue&type=script&lang=js"

import "./CxMenu.vue?vue&type=style&index=0&id=0a337d4b&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__